/**
 * @generated SignedSource<<ddca927a966837bcb385e30062d1fedb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DateRangeInput = {
  end: any;
  start: any;
};
export type APIOverviewQuery$variables = {
  dateRange: DateRangeInput;
};
export type APIOverviewQuery$data = {
  readonly apiStats: ReadonlyArray<{
    readonly CustomerName: string;
    readonly customerID: number;
    readonly totalCount: number;
  }>;
};
export type APIOverviewQuery = {
  response: APIOverviewQuery$data;
  variables: APIOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateRange"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dateRange",
        "variableName": "dateRange"
      }
    ],
    "concreteType": "_APIStat",
    "kind": "LinkedField",
    "name": "apiStats",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "CustomerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "APIOverviewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "APIOverviewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa8a544585bc6be450f5ae8855faf5d5",
    "id": null,
    "metadata": {},
    "name": "APIOverviewQuery",
    "operationKind": "query",
    "text": "query APIOverviewQuery(\n  $dateRange: DateRangeInput!\n) {\n  apiStats(dateRange: $dateRange) {\n    customerID\n    CustomerName\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "22f6f95b4f593f2a1617f7aeede3ab58";

export default node;
